var nb = require('../../nb');
var input = require('./Input');
module.exports = nb.define({
    view: {
        $name:'search-box',
        'class': "search-box",
        $html: [{
            'class': 'search-input-wrapper',
            $html: [{
                'class': 'input-prompt',
                tag: 'span',
                $text: '搜索'
            }, {
                $name: 'input',
                $type: input,
                $model: 'input'
            }, {
                $name: 'search',
                'class': 'iconfont icon-search header-search',
                tag: 'span'
            }, {
                // $name: 'close',
                // tag: 'i',
                // 'class': 'iconfont icon-close'
            }, {
                'class': ['search-popupmenu',nb.bind('active')],
                $html: [{
                    $name:'list',
                    $type:nb.view.List,
                    $model:'list'
                }]
            }]
        }]
    },
    method: {
        init: function () {
            var self = this;
            this.$('search').on('click', function () {
                var val = self.$('input').$().val();
                var code = encodeURI(val);
                window.location.href = 'products.html?key=' + code;
            });

            // this.$('close').on('click', function () {
            //     $(this).parents('.search-box').removeClass('active');
            // });

            // this.$('search-box').on('click', function () {
            //     debugger
            //     $(this).removeClass('active');
            // });
            this.$('input').$().on('input', function () {
                var val = self.$('input').$().val();
                var model = self.getModel();
                model.set('requireSearch',val);
            });
            this.$('list').$().on('click', '.search-menuitem',function () {
                var val = $(this).find('span').text();
                var code = encodeURI(val);
                window.location.href = 'products.html?key=' + code;
            });

        }
    }
});

//     {
//     'class':'btn-text',
//     style:{
//         'display':'inline-block'
//     },
//     $text:'搜索'
// },
// }
// ]
// ,{
//     'class':'watch-icon-wrapper',
//     $html:{
//         tag:'i',
//         'class':'icon'
//     }
// }
// 'class':['search-box-wrapper',nb.bind('searchBoxStatus')],
// $html:{
// $html:[
//     {
//     'class':'search-icon',
//     style:{
//         'background-image':'url("./image/mockup/common/search.png")',
//         'background-repeat':"no-repeat",
//         'vertical-align':'middle',
//         'margin':' 0 5px',
//         'width':'12px',
//         'height':'12px'
//     }
// },
//     {
//     'class':'input-box',


//////////////////
// WEBPACK FOOTER
// ../src/js/view/form/SearchBox.js
// module id = 26
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32